// extracted by mini-css-extract-plugin
export default {"mostrecent":"SmallSection_mostrecent__2okxw"};